/**
 * Created by Mehraz on 2022-02-22.
 */
import router from '../../router'
import {addDoc, collection, doc, getDoc, setDoc, updateDoc, onSnapshot} from "firebase/firestore";
import {getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut} from "firebase/auth";
export default {
  state: {
      user: null,
      subscriptions: null

  },
  mutations: {
      setUser (state, payload) {
          state.user = payload
      },
      setUserSubscriptions (state, payload) {
          state.subscriptions = payload
      }
  },
  actions: {
      signUserIn ({commit, rootState, dispatch}, payload) {
          // commit('setLoading', true)
          commit('clearError')
          let auth = getAuth()
          signInWithEmailAndPassword(auth, payload.email, payload.password)
              .then(user => {
                  commit('setLoading', false)
                  dispatch('fetchUserData', {uid: user.user.uid, emailVerified: user.user.emailVerified})
                  let db = rootState.db
                  return addDoc(collection(db, 'users', user.user.uid, 'logins'), {
                      ...user.user.reloadUserInfo}, { merge: true })
              })
              .catch(error => {
                      console.log(error)
                      commit('setLoading', false)
                      commit('setError', error)
                  }
              )
      },
      fetchUserData ({commit, rootState,dispatch}, payload) {
          // commit('setLoading', true)
          //   console.log(payload)
          let userRef = doc(rootState.db, 'users', payload.uid)
          getDoc(userRef)
              .then(doc => {
                  let data = doc.data()
                  let userProfile
                  if (data) {
                      userProfile = {...data}
                      userProfile.exists = true
                      // console.log('in fetch user data')
                      // console.log(payload)
                      if (payload.emailVerified) {
                          userProfile.emailVerified = payload.emailVerified
                      }
                      if (payload.isAnonymous) {
                          userProfile.isAnonymous = payload.isAnonymous
                      }
                  } else {
                      userProfile = {exists: false}
                  }

                  commit('setUser', userProfile)
                  commit('setLoading', false)
              })
              .then (()=> {
                  let subs = []
                  let subscriptionsRef = collection(rootState.db, 'users', payload.uid + '/subscriptions')
                  onSnapshot(subscriptionsRef, res => {
                      // console.log(res)
                      if (res && res.empty !== true) {
                          res.forEach(doc => {
                              let data = doc.data()
                              subs.push(data)
                          })
                          dispatch('setUserSubscriptions', subs)
                      }

                  })
              })
              .catch(error => {
                  console.log(error)
                  commit('setError', error)
                  commit('setLoading', false)
              })
      },
      onSignUp ({rootState, commit, dispatch}, payload) {
          let userInfo = {name: payload.name, email: payload.email, password: payload.password}
          let auth = getAuth()
          let user
          let db = rootState.db
          commit('setLoading', true)
          createUserWithEmailAndPassword(auth, userInfo.email, userInfo.password)
              .then((userCredential) => {
                  // Signed in
                  user = userCredential.user;

                  let userObj = {
                      uid: user.uid,
                      name: userInfo.name,
                      email: userInfo.email,
                      emailVerified: false
                  }
                  commit('setUser', userObj)
                  return setDoc(doc(db, 'users', user.uid), userObj, { merge: true })
              })
              .then (() => {
                  // fetch available subscriptions
                  let subscriptionsRef = collection(db, 'subscriptions')
                  onSnapshot(subscriptionsRef, res => {
                      if (res && res.empty !== true) {
                          let subs = []
                          let sorted = []
                          res.forEach(doc => {
                              let data = doc.data()
                              // console.log(data)
                              subs.push(data)
                          })
                          subs.forEach(sub => {
                              if(sub.active) {
                                  let subObj = {...sub}
                                  subObj.active = false
                                  sorted.push(subObj)
                                  return setDoc(doc(db, 'users', user.uid, 'subscriptions', subObj.id), subObj)
                              }
                          })
                          console.log(sorted)
                          //set subs to users profile
                      }
                  })
              })
              .then(() => {
                  dispatch('fetchUserData', {uid: user.uid})
                  router.push('/')
                  commit('setLoading', false)
              })
              .catch((error) => {
                  commit('setLoading', false)
                  commit('setError', error)
                  console.log(error)
              });
      },
      updateUserProfile({commit, rootState}, payload) {
          commit('setLoading', true)
          let userRef = doc(rootState.db, 'users', payload.uid)
          updateDoc(userRef, payload)
              .then(() => {
                  // console.log(payload)
                  commit('setUser', payload)
                  commit('setLoading', false)
              })
              .catch(error => {
                  console.log(error)
                  commit('setError', error)
                  commit('setLoading', false)
              })
      },
      setUserSubscriptions ({commit}, payload) {
          commit('setUserSubscriptions', payload)
      },
      logout ({commit}) {
          let auth = getAuth()
          signOut(auth)
              .then(() => {
                  router.push('/')
                  window.location.reload();
                  //console.log('user signed out')
              })

          commit('setUser', null)
      }
  },
  getters: {
      user (state) {
          return state.user
      },
      subscriptions (state) {
          return state.subscriptions
      }
  }
}
